import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
const DEFAULT_ICON_SIZE = 16;
export const StyledFontAwesomeIcon = styled(FontAwesomeIcon) `
  width: var(--falcon-size, ${({ $size = DEFAULT_ICON_SIZE }) => pxToRem($size)});
  height: var(--falcon-size, ${({ $size = DEFAULT_ICON_SIZE }) => pxToRem($size)});
  color: var(--falcon-color, ${({ $color = 'gray.1000' }) => themeGet(`colors.${$color}`)});
`;
